import React from "react"

export const innerPageIframeStyle: React.CSSProperties = {
    width: "100%",
    height: "100%",
    border: "none",
}

export const fullPageIframeStyle: React.CSSProperties = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    border: "none",
}
